import React from "react";
import { Grid2 } from "@mui/material";
import Lottie from "react-lottie";
import styles from "./DomainLoading.module.scss";
import Domain from "../../../../../../../../GlobalAssets/Animations/DomainLoading.json";
import { ReactComponent as LoadingDomain } from "../../../../../../../../GlobalAssets/svg/DomainLoading.svg";

export default function DomainLoading() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Domain,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid2 className={styles.DomainLoadingContainer}>
      <Grid2 className={styles.DomainLoading}>
        <Grid2>
          <LoadingDomain />
        </Grid2>
        <Grid2 className={styles.Lottie}>
          <Lottie options={defaultOptions} />
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
